import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpsertHotspotsStateMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.AccountsHotspotsStateInput;
}>;


export type UpsertHotspotsStateMutationPage = { readonly __typename?: 'RootMutationType', readonly upsertHotspotsState: { readonly __typename?: 'AccountsHotspotsState', readonly mediaplanHideAt?: string | null, readonly funnelHideAt?: string | null, readonly feedHideAt?: string | null, readonly sensorsHideAt?: string | null, readonly companyId: string } };


export const UpsertHotspotsStateDocument = gql`
    mutation UpsertHotspotsState($companyId: ID!, $input: AccountsHotspotsStateInput!) {
  upsertHotspotsState(input: $input, companyId: $companyId) {
    mediaplanHideAt
    funnelHideAt
    feedHideAt
    sensorsHideAt
    companyId
  }
}
    `;
export type UpsertHotspotsStateMutationFn = Apollo.MutationFunction<UpsertHotspotsStateMutationPage, UpsertHotspotsStateMutationVariables>;

/**
 * __useUpsertHotspotsStateMutation__
 *
 * To run a mutation, you first call `useUpsertHotspotsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHotspotsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHotspotsStateMutation, { data, loading, error }] = useUpsertHotspotsStateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertHotspotsStateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHotspotsStateMutationPage, UpsertHotspotsStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHotspotsStateMutationPage, UpsertHotspotsStateMutationVariables>(UpsertHotspotsStateDocument, options);
      }
export type UpsertHotspotsStateMutationHookResult = ReturnType<typeof useUpsertHotspotsStateMutation>;
export type UpsertHotspotsStateMutationResult = Apollo.MutationResult<UpsertHotspotsStateMutationPage>;
export type UpsertHotspotsStateMutationOptions = Apollo.BaseMutationOptions<UpsertHotspotsStateMutationPage, UpsertHotspotsStateMutationVariables>;